import { AuthChallenge } from '../data/AuthChallenge';
import * as authorization from 'auth-header';
import { authChallengeErrorString } from '../../AuthErrors';
import { headerConstants } from '../../AuthConstants';
import { logConstants } from '../../../utils/Constants';
import { Logger } from '../../Logger';
export class AuthChallengeParser {
	private static instance: AuthChallengeParser;

	public static getInstance(): AuthChallengeParser {
		if (!AuthChallengeParser.instance) {
			AuthChallengeParser.instance = new AuthChallengeParser();
		}
		return AuthChallengeParser.instance;
	}

	parse(authenticateHeaderValue: string): AuthChallenge {
		try {
			const parsed = authorization.parse(authenticateHeaderValue.trim());
			if (
				parsed.scheme.toLowerCase() === headerConstants.CITRIX_AUTH_SCHEME.toLowerCase()
			) {
				return new AuthChallenge(parsed.params);
			}
			throw new Error(authChallengeErrorString.DSAUTH_UNSUPPORTED_AUTH_CHALLENGE_FORMAT);
		} catch (e) {
			if (
				e.message == authChallengeErrorString.DSAUTH_UNSUPPORTED_AUTH_CHALLENGE_FORMAT
			) {
				throw e;
			}
			Logger.getInstance().write(
				logConstants.ERROR,
				authChallengeErrorString.DSAUTH_AUTH_CHALLENGE_PARSE_ERROR + ':' + e.stack
			);
			throw new Error(authChallengeErrorString.DSAUTH_AUTH_CHALLENGE_PARSE_ERROR);
		}
	}
}
